module.exports = __webpack_public_path__ + "img/two_ad.b2c88fd1.jpg";